<script>
  import { Link } from 'svelte-routing'
  import ContactButtonAtom from '~/Components/Atoms/ContactButton'
  import Wrap from '~/Components/Layout/Wrap'
</script>

<div class="footer">

  <div class="footer__middleground" />

  <img src="/static/shapes/rectangle.svg" alt="" class="footer__background">

  <Wrap>

    <div class="footer__top">

      <div class="footer__copy">

        <h4>How can we help?</h4>

        <p>We have your best interests at heart, so please do not hesitate to drop us a message.</p>

        <ContactButtonAtom footer={true} />

      </div>

      <div class="footer__links">

        <div class="footer__menu">

          <h6 class="footer__menu-title">Useful links</h6>

          <Link to="/for-you">Just for you</Link>

          <Link to="/for-your-career">For your career</Link>

          <Link to="/mentors">Mentors to help</Link>

          <Link to="/contact">Contact us</Link>

        </div>

        <div class="footer__menu">

          <h6 class="footer__menu-title">Legal</h6>

          <a href="/static/docs/terms.pdf" target="_blank">Terms and Conditions</a>

          <a href="https://cdn.next15.com/privacy-policy.pdf" target="_blank">Privacy</a>

          <a href="/static/docs/cookie-policy.pdf" target="_blank">Cookies</a>

        </div>

      </div>

    </div>

    <div class="footer__sub">

      <Link to="/">

        <h4 class="heading">Next4Me<span class="accent">.</span></h4>

      </Link>

      <small>© Next4Me 2020. All rights reserved</small>

    </div>

  </Wrap>

</div>

<style lang="scss">
  .footer {

    display: flex;
    align-items: center;
    justify-content: center;
    height: 30rem;
    padding-top: 8rem;
    position: relative;
    overflow: hidden;
    width: 100%;

    :global(.wrap) {
      flex-grow: 1;
    }
    &__top {
      display: flex;
      position: relative;
      justify-content: space-between;
      padding-top: 10rem;
      flex-grow: 1;
      margin: 0 auto;
      width: 90%;
    }
    &__copy {
      h4 {
        font-weight: bold;
        color: white;
        margin-bottom: 1rem;
      }
      p {
        color: white;
        font-size: 0.875rem;
        max-width: 20rem;
      }
    }
    &__background {
      position: absolute;
      z-index: -15;
      bottom: 0;
      top: 80px;
      left: -180px;
      height: 40rem;
      width: 40rem;
      margin: 0 auto;
      transform: rotate(25deg);
    }
    &__middleground {
      position: absolute;
      background-color: var(--heading-colour);
      border-radius: 12.5rem;
      width: 105%;
      height: 50rem;
      z-index: -10;
      top: 200px;
      left: 40px;
      transform: rotate(5deg);

      @media only screen and (max-width: 768px) {
        left: 10px;
      }

    }
    &__links {
      display: flex;
    }
    &__menu {
      display: flex;
      flex-direction: column;
      margin-left: 3rem;
      &:last-child {
        margin-left: 4.625rem;
      }
      &-title {
        color: white;
        font-weight: 600;
        font-size: 0.875rem;
        margin-bottom: 1rem;
      }
      :global(a) {
        color: white;
        font-weight: 300;
        margin-bottom: 0.75rem;
        font-size: 0.875rem;
        padding-bottom: 0.25rem;
        position: relative;
        width: fit-content;
        &::before {
          content: "";
          position: absolute;
          bottom: 0;
          height: 2px;
          width: 0;
          left: 30%;
          border-bottom: 1px solid white;
          -webkit-transition: width .5s;
          transition: width .5s;
        }
        &:hover::before {
          width: 70%;
        }
      }
    }
    &__sub {
      display: flex;
      padding: 4rem 0 2rem 0;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      width: 90%;
      a h4, small {
        color: white;
        font-weight: 300;
      }
    }

    @media only screen and (max-width: 576px) {
      height: fit-content;
      &__middleground {
        top: 100px;
        left: -12px;
        width: 40rem;
        transform: rotate(3deg);
        border-radius: 8rem;
        height: 100%;
      }
      &__top {
        flex-direction: column;
        margin: 0;
        width: unset;
        padding: 5rem 0rem 0rem 0rem;
        margin-bottom: 2rem;
      }
      &__links {
        flex-direction: column;
      }
      &__menu.footer__menu {
        margin: 1rem 0;
      }
      &__sub {
        padding: 1rem 0;
        margin: unset;
        flex-direction: column;
        align-items: flex-start;
        .heading {
          margin-bottom: 1rem;
        }
      }
    }

  }
</style>
